import { AnyAaaaRecord } from "dns";
import { httpApi } from "./http.api";

export const getRolesData = (): Promise<any[]> =>
  httpApi.get<any[]>("hiring/job/?all=True").then((data: any) => data.data);

export const getRolesDataPagination = (
  pageNumber: any,
  orderings: any = ""
): Promise<{
  count: number;
  next: string;
  previous: string | undefined;
  results: any[];
}> =>
  httpApi
    .get<{
      count: number;
      next: string;
      previous: string | undefined;
      results: any[];
    }>("hiring/job/?page=" + pageNumber + "&ordering=" + orderings)
    .then((data: any) => data.data);

export const getDEIStat = (id: any): Promise<any[]> =>
  httpApi.get<any[]>(`hiring/job-stats/${id}/`).then((data: any) => data.data);

export const deleteRole = async (id: number): Promise<any> => {
  return httpApi.delete<any>(`hiring/job/${id}/`, {});
};

export const addCandidateToRole = (pipelinePayload: any): Promise<any> => {
  return httpApi
    .post<any>("hiring/custom-assignment/add-candidate-to-job/", {
      ...pipelinePayload,
    })
    .then(({ data }) => data);
};

export const addRole = (rolePayload: any): Promise<any> =>
  httpApi.post<any>("hiring/job/", rolePayload).then(({ data }) => data);

export const updateRole = (roleId: any, rolePayload: any): Promise<any> =>
  httpApi
    .patch<any>("hiring/job/" + roleId, rolePayload)
    .then(({ data }) => data);

export const getRole = (id: any): Promise<any[]> =>
  httpApi.get<any[]>("hiring/job/" + id).then((data: any) => data.data);

export const importCandidateToRole = (candidateUrl: any): Promise<any> =>
  httpApi
    .post<any>("hiring/custom-assignment/import-candidate-to-job/", {
      ...candidateUrl,
    })
    .then(({ data }) => data);

export const deleteRoles = (jobIds: any): Promise<any> =>
  httpApi
    .post<any>("hiring/delete-jobs/", {
      jobs: jobIds ? jobIds : [],
    })
    .then(({ data }) => data);

export const rejectCandidateFromJob = (payload: any): Promise<any> =>
  httpApi
    .post<any>("hiring/reject-candidate/reject-candidate-for-job/", {
      candidates: [...payload.candidates],
      jobs: [...payload.jobs],
      is_rejected: true,
    })
    .then(({ data }) => data);

export const getSuggestedCandidate = (
  id: any,
  page: number = 1
): Promise<any> =>
  httpApi
    .get<any>("hiring/suggested-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getShortListedCandidate = (
  id: any,
  page: number = 1
): Promise<any> =>
  httpApi
    .get<any>("hiring/shortlisted-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getImportedCandidate = (id: any, page: number = 1): Promise<any> =>
  httpApi
    .get<any>("hiring/imported-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getRejectedCandidates = (
  id: any,
  page: number = 1
): Promise<any> =>
  httpApi
    .get<any>("hiring/rejected-candidates-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const getSearchesOfJob = (id: any, page: any = 1): Promise<any> =>
  httpApi
    .get<any>("hiring/searches-for-job/" + id + "/?page=" + page)
    .then(({ data }) => data);

export const downLoadShortListCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/shortlisted-candidates/" + id + "/")
    .then(({ data }) => data);

export const downLoadImportCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/imported-candidates/" + id + "/")
    .then(({ data }) => data);

export const downloadRejectedCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/rejected-candidates/" + id + "/")
    .then(({ data }) => data);

export const downloadSuggestedCandidate = (id: any): Promise<any> =>
  httpApi
    .get<any>("hiring/download-candidates/suggested-candidates/" + id + "/")
    .then(({ data }) => data);
